<template>
  <popup ref="popup" :loading="popupLoading">
    <div slot="body">
      <el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true" label-width="80px"
        :rules="rules">

        <el-row>
          <el-col :span="8">
            <el-form-item prop="name">
              {{ parameter.name }} ，已交：{{ parameter.paied }}/{{ parameter.costs }}   </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16">
            <el-form-item label="收款账户" prop="cpttpname">
              <el-select v-model="formParameter.cpttpname" placeholder="请选择">
                <el-option v-for="item in cwcnts" :key="item.cpttpname" :label="item.cpttpname" :value="item.cpttpname">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="缴费金额" prop="name">
              <el-input   placeholder="缴费金额"
                v-model="formParameter.paied" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="到账时间" prop="jftm">
              <el-date-picker v-model="formParameter.jftm" type="date" placeholder="选择日期"
                value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>

          <!--el-col :span="16">
            <el-form-item label="扣保证金" prop="bzj">
              <el-input v-model="formParameter.bzj" placeholder="如有预计收不回的保证金可填" autocomplete="off"></el-input>
            </el-form-item>
          </el-col-->
        </el-row>
        <!--el-row v-if="isShow == 2">
          <el-col :span="8">
            <el-form-item label="学习能力" prop="pjtxt1">
              <el-select v-model="formParameter.pjtxt1" placeholder="请选择">
                <el-option v-for="item in ['中等', '良好', '较差', '优秀']" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="学习态度" prop="pjtxt2">
              <el-select v-model="formParameter.pjtxt2" placeholder="请选择">
                <el-option v-for="item in ['中等', '良好', '较差', '优秀']" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="isShow == 2">
          <el-col :span="24">
            <el-form-item label="技术综评" prop="pjtxt3"><el-input type="textarea" rows="2" placeholder="技术综合评价"
                v-model="formParameter.pjtxt3" autocomplete="off"></el-input></el-form-item>
          </el-col>
        </el-row-->
        <el-row  >
          <el-col :span="24">
            <el-form-item label="缴费说明" prop="pjtxt3"><el-input type="textarea" rows="2" placeholder="缴费说明"
                v-model="bmtremark" autocomplete="off"></el-input></el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">提 交</el-button>
      <el-button @click="close">取 消</el-button>
    </div>
  </popup>
</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/stu/stu.js";
import apiClz from "@/api/edu/clazz/clazz.js";
import apiCwcnt from "@/api/cw/cwacount.js";

export default {
  name: "add2",
  components: {
    popup,
  },
  data() {
    return {
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      parameter: {},
      formParameter: {},
      bmtremark:"",
      me: {},
      rules: {},
      cwcnts: [],
      isShow: 0,
      clzess: undefined
    };
  },
  methods: {
    //打开弹框
    open(parameter, me, type, title, disabled, size) {
      this.parameter = parameter;
      this.formParameter.id = parameter.id ;
      this.bmtremark = parameter.bmtremark ;
      this.me = me
      this.disabled = disabled;
      this.isShow = type
      this.$refs.popup.open(title, "45%");
      this.$nextTick(() => {
        if ('tr' == this.me.role || 'mgr2' == this.me.role2) {
            this.isShow = 2
          } else if ('ad' == this.me.role || 'mgr' == this.me.role2) {
            apiCwcnt.list({inUse:1}, (res2) => {
              this.cwcnts = res2.data;
            });
            this.isShow = 3
          }
      });
    },
    //关闭弹框
    close() {
      this.disabled = false;
      this.parameter = {}
      this.formParameter = {}
      this.$refs.popup.close();
    },
    //提交表单
    confirm() {

      this.confirmLoading = true;
  
      // 老师或教学总监
      if ('tr' == this.me.role || 'mgr2' == this.me.role2) {
        delete this.formParameter.id
        this.formParameter.stuid  = this.parameter.id
        this.formParameter.pjname1  = '学习能力'
        this.formParameter.pjname2  = '学习态度'
        this.formParameter.pjname3  = '技术综评'
        this.formParameter.bmtremark = this.bmtremark 

        api.jspj(
          this.formParameter,
          (response) => {
            this.$utils.msg.success(response.msg);
            this.confirmLoading = false;
            this.close();
            this.$parent.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
            this.confirmLoading = false;
          });
      } else {
        //跟进财务数据
        let parameter = {
          id: this.formParameter.id,
          cpttpname: this.formParameter.cpttpname,
          bmtremark: this.bmtremark,
          jftm: this.formParameter.jftm,
          paied: this.formParameter.paied 
        }
        api.genJW(parameter, res => {
          this.$utils.msg.success("跟进成功.");
          this.confirmLoading = false;
          this.close();
          this.$parent.list();
        }, (res) => {
          this.$utils.msg.warning("跟进失败.");
          this.confirmLoading = false;
        });

      }
    } 
    
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>
